import * as React from 'react'
import styled from 'styled-components'

interface CollapseButtonProps {
  defaultCollapsed?: boolean
  idLabel?: any
  onClick: (collapsed: boolean) => void
}

export const CollapseButton = (props: CollapseButtonProps) => {
  const { defaultCollapsed, onClick, idLabel } = props

  const [collapsed, setCollapsed] = React.useState(defaultCollapsed)

  const handleOnClick = () => {
    onClick(!collapsed)
    setCollapsed(!collapsed)
  }

  return (
    <Container onClick={handleOnClick} id={idLabel}>
      {collapsed ? (
        <i className='fas fa-chevron-down' />
      ) : (
        <i className='fas fa-chevron-up' />
      )}
    </Container>
  )
}

const Container = styled.div`
  margin-left: auto;
  padding-left: 7.5%;
  font-size: 20px;
  cursor: pointer;
`

export default CollapseButton



// WEBPACK FOOTER //
// ./src/components/atoms/input/buttons/Collapse.tsx